<template>
    <v-container>
        <v-row>
            <v-col
                cols="12"
            >
                <v-progress-linear
                    :value="profileperc"
                    height="40"
                    class="mb-4"
                    color="green darken-2"
                    dark
                    @click="GoToProfile"
                    style="cursor: pointer;"
                >
                    Your profile is {{ Math.ceil(profileperc) }}% complete
                </v-progress-linear>

                <div class="d-none">
                    <img class="img-fluid" :src="profilepic" @load="LoadedProfilePic">
                    <img class="img-fluid" :src="valididpic" @load="LoadedValidId">
                </div>
            </v-col>

            <!-- added -->
            <!-- <v-col
                cols="12"
            >
                <v-btn
                    @click="UBTest"
                >
                    UBTest
                </v-btn>
            </v-col> -->
            <!-- end -->

            <!-- <v-col
                cols="12"
            >
                <v-text-field
                    label="Search a Service"
                    v-model="search"
                    dense
                    outlined
                    hint="search from the list of services below"
                    persistent-hint
                ></v-text-field>
            </v-col> -->

            <v-col
                cols="12"
                lg="4"
                md="6"
                sm="12"
                v-if="search.toString().length == 0 || (search.toString().length > 0 && `View/Edit Profile`.toLowerCase().indexOf(search.toString().toLowerCase()) > -1)"
            >
                <v-card
                    elevation="6"
                    color="deep-orange darken-1"
                    dark
                    @click="GoToProfile"
                >
                    <v-card-title>
                        <v-icon large class="mr-6">mdi-face-outline</v-icon>
                        <p class="text-wrap">View/Edit Profile</p>
                    </v-card-title>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            dark
                            x-small
                            @click="GoToProfile"
                        >
                            <v-icon class="mr-2">mdi-link</v-icon>Go to Profile
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <!-- <v-col
                cols="12"
                lg="4"
                md="6"
                sm="12"
                v-if="search.toString().length == 0 || (search.toString().length > 0 && `Use Fortunepay with DigitalTuguegarao`.toLowerCase().indexOf(search.toString().toLowerCase()) > -1)"
            >
                <v-card
                    elevation="6"
                    color="deep-orange darken-1"
                    dark
                    @click="GoToFortunePay"
                >
                    <v-card-title class="text-wrap">
                        <v-img src="images/fortunepay-logo.png" contain max-height="30" max-width="30" class="mr-6"></v-img>
                        <p class="text-wrap" style="height: 32px;">Use Fortunepay<br v-if="!$vuetify.breakpoint.sm" /> with DigitalTuguegarao</p>
                    </v-card-title>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            dark
                            x-small
                            @click="GoToFortunePay"
                        >
                            <v-icon class="mr-2">mdi-link</v-icon>Download Fortunepay
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col> -->

            <v-col
                cols="12"
                lg="4"
                md="6"
                sm="12"
                v-if="(search.toString().length == 0 || (search.toString().length > 0 && `Government Services`.toLowerCase().indexOf(search.toString().toLowerCase()) > -1))"
            >
                <v-card
                    elevation="6"
                    color="deep-orange darken-1"
                    dark
                    @click="GoToGovServices"
                >
                    <v-card-title class="text-wrap">
                        <v-icon large class="mr-6">mdi-bank-outline</v-icon>
                        <p class="text-wrap">Government Services</p>
                    </v-card-title>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            dark
                            x-small
                            @click="GoToGovServices"
                        >
                            <v-icon class="mr-2">mdi-link</v-icon>Go to Government Services
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <!-- <template v-for="(item, i) in items.filter(x => {
                    return search.toString().length == 0 || (search.toString().length > 0 && x.name.toLowerCase().indexOf(search.toString().toLowerCase()) > -1)
                })">
                <v-col
                    cols="12"
                    lg="4"
                    md="6"
                    sm="12"
                    :key="`item-container-${i}`"
                >
                    <v-card
                        elevation="6"
                        color="deep-orange darken-1"
                        dark
                        @click="IsComingSoon(item)"
                    >
                        <v-card-title>
                            <v-icon large class="mr-6">{{ item.icon }}</v-icon>
                            <p class="text-wrap">{{ item.name }}</p>
                        </v-card-title>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <template v-if="item.comingsoon">
                                <v-btn
                                    text
                                    dark
                                    x-small
                                >
                                    <v-icon class="mr-2">mdi-timer-sand</v-icon>Coming Soon!
                                </v-btn>
                            </template>
                            <template v-else>
                                <v-btn
                                    text
                                    dark
                                    x-small
                                    @click="Nav(item.link)"
                                >
                                    <v-icon class="mr-2">mdi-link</v-icon>Go to Service
                                </v-btn>
                            </template>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </template> -->
        </v-row>

        <v-btn
            fab
            dark
            large
            color="#0086cd"
            fixed
            right
            bottom
            @click="GoToFortunePay"
        >
            <v-img
                :src="`images/fortunepay.png`"
                max-height="50"
                contain
            ></v-img>
        </v-btn>
    </v-container>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import moment from "moment"

export default {
    name: 'dashboard',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - Dashboard',
    },
    data() {
        return {
            profilepic: '',
            valididpic: '',
            profilepicloaded: false,
            valididpicloaded: false,
            profileperc: 0,
            citizen: {},
            items: [],
            search: '',
            // comingsoon: ['Real Estate Tax Payment', 'Payment History', 'Pay Business License', 'Retirement of Business'],
            comingsoon: ['Payment History', 'Retirement of Business'],
            exceptfor: 'TTTL_000003',
            sessionid: '',
        }
    },
    methods: {
        UBTest() {
            axios({
                method: 'get',
                url: `${this.domain}/ubtest-cipher`,
            })
                .then(response => {
                    console.log(response.data.url.toString())

                    setTimeout(() => {
                        window.location = response.data.url.toString()
                    }, 5000)
                })
        },
        GoToGovServices() {
            window.location.href = `https://egov.tuguegaraocity.gov.ph:3000/sas`
            // window.location.href = `https://egov.tuguegaraocity.gov.ph:3000/sign-in/${this.sessionid}`
            // window.location.href = `https://egov.tuguegaraocity.gov.ph:3000`
        },
        GoToFortunePay() {
            // window.location = `https://play.google.com/store/apps/details?id=com.fp.fortunepayapp`
            // this.$router.push(`https://play.google.com/store/apps/details?id=com.fp.fortunepayapp`)
            window.open(`https://play.google.com/store/apps/details?id=com.fp.fortunepayapp`, '_blank')
        },
        IsComingSoon(item) {
            if(item.comingsoon == false){
                this.Nav(item.link)
            }
        },
        GoToProfile() {
            this.$router.push({
                name: 'profile'
            }).catch(()=>{})
        },
        LoadedProfilePic() {
            this.profilepicloaded = true

            this.ComputeProfilePerc()
        },
        LoadedValidId() {
            this.valididpicloaded = true

            this.ComputeProfilePerc()
        },
        Nav(l) {
            window.location.href = l.toString()
        },
        dashboard() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_dashboard_modules`,
                data: {
                    rand: Math.random(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        const modules = this.$jwt.decode(response.data.modules, this.jwtsecret)

                        this.items = modules.modules.map(x => {
                            x.comingsoon = this.comingsoon.indexOf(x.name.toString()) > -1

                            return x
                        })
                    }
                })
                .catch(() => {

                })
        },
        ComputeProfilePerc() {
            let totalChecked = 0
            let totalFields = 0
            // const toCheck = this.citizen.accounttype.toString() == 'individual' ? ['username', 'firstname', 'middlename', 'lastname', 'gender', 'birthdate', 'mobile', 'email', 'fathers_name', 'mothers_maiden_name', 'civil_status', 'nationality', 'tin', 'birthplace', 'occupation', 'educational_attainment', 'signatureloc'] : ['username', 'companyname', 'businesstype', 'date_established', 'tin', 'signatureloc']
            const toCheck = this.citizen.accounttype.toString() == 'individual' ? ['username', 'firstname', 'middlename', 'lastname', 'gender', 'birthdate', 'mobile', 'email', 'civil_status', 'nationality', 'tin', 'birthplace', 'occupation', 'signatureloc'] : ['username', 'companyname', 'businesstype', 'date_established', 'tin', 'signatureloc']

            totalFields = toCheck.length

            toCheck.forEach(x => {
                if(this.citizen[x] && this.citizen[x].toString().length > 0){
                    totalChecked++
                }
            })

            totalFields += 11

            if(this.citizen.address.permanent.street && this.citizen.address.permanent.street.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.permanent.brgy && this.citizen.address.permanent.brgy.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.address1 && this.citizen.address.present.address1.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.address2 && this.citizen.address.present.address2.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.city && this.citizen.address.present.city.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.province && this.citizen.address.present.province.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.country && this.citizen.address.present.country.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.address.present.zipcode && this.citizen.address.present.zipcode.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.incaseofemergency && this.citizen.incaseofemergency.name && this.citizen.incaseofemergency.name.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.incaseofemergency && this.citizen.incaseofemergency.address && this.citizen.incaseofemergency.address.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.incaseofemergency && this.citizen.incaseofemergency.contactnumber && this.citizen.incaseofemergency.contactnumber.toString().length > 0){
                totalChecked++
            }

            if(this.citizen.accounttype.toString() != 'individual'){
                totalFields += 5

                if(this.citizen.representative && this.citizen.representative.name && this.citizen.representative.name.toString().length > 0){
                    totalChecked++
                }

                if(this.citizen.representative && this.citizen.representative.address && this.citizen.representative.address.toString().length > 0){
                    totalChecked++
                }

                if(this.citizen.representative && this.citizen.representative.contactnumber && this.citizen.representative.contactnumber.toString().length > 0){
                    totalChecked++
                }

                if(this.citizen.secdti && this.citizen.secdti.length > 0){
                    totalChecked++
                }

                if(this.citizen.boardresolutionauthorizingrep && this.citizen.boardresolutionauthorizingrep.length > 0){
                    totalChecked++
                }
            }

            totalFields+=2

            if(this.profilepicloaded){
                totalChecked++
            }

            if(this.valididpicloaded){
                totalChecked++
            }

            // console.log(`${totalChecked} ${totalFields}`)

            this.profileperc = Math.abs( Math.round( (totalChecked / totalFields) * 100 ) )
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)

        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        if(!this.citizen.birthplace){
            this.citizen.birthplace = ''
        }

        if(!this.citizen.spousename){
            this.citizen.spousename = ''
        }

        if(!this.citizen.occupation){
            this.citizen.occupation = ''
        }

        if(!this.citizen.educational_attainment){
            this.citizen.educational_attainment = ''
        }

        if(!this.citizen.extensionname){
            this.citizen.extensionname = ''
        }

        if(!this.citizen.incaseofemergency){
            this.citizen.incaseofemergency = {
                name: '',
                address: '',
                contactnumber: '',
            }
        }

        if(this.citizen.date_established.toString().length == 0){
            this.citizen.date_established = moment().toISOString().substr(0, 10)
        }

        this.citizen.secdti = []
        this.citizen.secdtidata = []
        this.citizen.boardresolutionauthorizingrep = []
        this.citizen.boardresolutionauthorizingrepdata = []

        this.citizen.tugueresident = this.citizen.tugueresident || false

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        if(this.citizen.imgUrl){
            this.profilepic = `${this.domain}/serve/staticfiles/${this.citizen.imgUrl.replace('public/files/', '')}`
        }

        if(this.citizen.imgUrlValidId){
            this.valididpic = `${this.domain}/serve/staticfiles/${this.citizen.imgUrlValidId.replace('public/files/', '')}`
        }

        setTimeout(() => {
            this.ComputeProfilePerc()
        }, 3000)

        this.dashboard()

        this.sessionid = this.$session.get('crmusersessionsignature')
    }
}
</script>